import { render } from "./SceletonCard.vue?vue&type=template&id=294c1094&scoped=true"
import script from "./SceletonCard.vue?vue&type=script&lang=js"
export * from "./SceletonCard.vue?vue&type=script&lang=js"

import "./SceletonCard.vue?vue&type=style&index=0&id=294c1094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294c1094"]])

export default __exports__